import { useState, FunctionComponent, useCallback } from "react";
import { resendOtp } from "@store/visitWidgetApi";
import { loginAction } from "@store/auth/actions/loginAction";
import { useAppDispatch } from "@store/store";
import { AuthInstructions } from "../../components/AuthInstructions/AuthInstructions";
import { AuthLinkButton } from "../../components/AuthLinkButton/AuthLinkButton";
import { useTranslation } from "react-i18next";
import { AuthError } from "../../components/AuthError/AuthError";
import { FormStatus } from "../../../../components/formFields/FormStatus";
import { Form } from "antd";
import { AuthSubmitButton } from "../../components/AuthSubmitButton/AuthSubmitButton";
import { AdminOtpField } from "../../../../components/formFields/AdminOtpField/AdminOtpField";
import { logInfo } from "@lib/logger";
const AdminOtpVerify: FunctionComponent = () => {
  const [state, setState] = useState<{ status: FormStatus }>({
    status: "idle",
  });
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const handleResendCode = useCallback(async () => {
    setState({ status: "fetching" });

    try {
      await resendOtp();
      setState({ status: "idle" });
    } catch (error) {
      logInfo(error);
      setState({ status: "error" });
    }
  }, []);

  const handleVerifyCode = useCallback(
    async (values: { otp: string }) => {
      setState({ status: "fetching" });
      try {
        await dispatch(loginAction({ otp: values.otp }));
        setState({ status: "success" });
      } catch (_error) {
        setState({ status: "error" });
      }
    },
    [dispatch],
  );

  const disabled = state.status === "fetching" || state.status === "success";

  return (
    <>
      <AuthInstructions />
      <div className="form-container">
        <Form
          form={form}
          name="adminOtpVerify"
          layout="vertical"
          onFinish={handleVerifyCode}
          disabled={disabled}
          initialValues={{ otp: "" }}>
          <AdminOtpField disabled={disabled} />

          <div className="form-button-container">
            <AuthSubmitButton
              label={t("screens.auth.adminOtpVerify.submit")}
              disabled={disabled}
            />
            <AuthLinkButton
              disabled={disabled}
              onPress={handleResendCode}
              label={t("screens.auth.adminOtpVerify.resendCode")}
            />
          </div>
        </Form>
      </div>

      {state.status === "error" && <AuthError />}
    </>
  );
};

export { AdminOtpVerify };
